export const ADS_RENT = 'ads.HIRE';
export const ADS_STOP = 'ads.STOP';
export const ADS_BOUGHT_ADS_LOADED = 'ads.ADS_BOUGHT_ADS_LOADED';
export const ADS_AVAILABLE_ADS_LOADED = 'ads.ADS_AVAILABLE_ADS_LOADED';
